import { parseJwt } from "../api/OAuth";

export const saveUserProfileFromToken = (token) => {
  if (!token || token === "undefined") {
    return null;
  }

  try {
    const jwt = parseJwt(token);
    
    const userProfile = {
      email: jwt.email || null,
      roles: jwt.roles || null,
      company: jwt.company || null,
      id: jwt.id || null,
      position: jwt.position || null,
    };

    localStorage.setItem("userProfile", JSON.stringify(userProfile));
    
    return userProfile;
  } catch (error) {
    console.error("Error parsing token for user profile:", error);
    return null;
  }
};

export const getUserProfileFromStorage = () => {
  try {
    const cachedProfile = localStorage.getItem("userProfile");
    if (cachedProfile) {
      return JSON.parse(cachedProfile);
    }
    return null;
  } catch (error) {
    console.error("Error reading user profile from storage:", error);
    return null;
  }
};

export const clearUserProfile = () => {
  localStorage.removeItem("userProfile");
};

